export class PageViewDeduper {
  private lastPath: string | null = null;

  private lastTimestamp = 0;

  private readonly dedupeMs: number;

  constructor(dedupeMs: number) {
    this.dedupeMs = dedupeMs;
  }

  shouldDispatch(path: string, timestamp = Date.now()): boolean {
    if (
      this.lastPath === path &&
      timestamp - this.lastTimestamp < this.dedupeMs
    ) {
      return false;
    }

    this.lastPath = path;
    this.lastTimestamp = timestamp;
    return true;
  }

  reset(): void {
    this.lastPath = null;
    this.lastTimestamp = 0;
  }
}
